import { PUBLIC_ROUTES } from '../Routes/routes'

export const buildCompanyLoginUrl = (companyToken) => {
  if (!companyToken) return ''
  const path = PUBLIC_ROUTES.login_company.replace(
    ':companyToken',
    encodeURIComponent(companyToken)
  )
  return `${window.location.origin}${path}?auto=true`
}

export const extractCompanyTokenFromCompany = (company = {}) => {
  const culture = company.culture
  if (culture == null || culture === '') return null
  return culture
}

export const extractCompanyTokenFromResponse = (res = {}) =>
  extractCompanyTokenFromCompany(res) ??
  res.companyToken ??
  res.company_token ??
  null

export const saveCompanyCredentials = (companyName, credentials) => {
  const companyToken = credentials.companyToken ?? null
  const loginUrl = buildCompanyLoginUrl(companyToken)
  const pending = JSON.parse(localStorage.getItem('company_credentials_pending') || '{}')
  pending[companyName.trim().toLowerCase()] = { ...credentials, companyToken, loginUrl }
  localStorage.setItem('company_credentials_pending', JSON.stringify(pending))
}

export const saveCompanyCredentialsById = (companyId, credentials) => {
  const companyToken = credentials.companyToken ?? null
  const loginUrl = buildCompanyLoginUrl(companyToken)
  const all = JSON.parse(localStorage.getItem('company_credentials') || '{}')
  all[companyId] = { ...credentials, companyToken, loginUrl }
  localStorage.setItem('company_credentials', JSON.stringify(all))
}
